var exports = {
  "i": "LiveBadge.module__liveBadge___QlFoOU",
  "f": "LiveBadge.module__liveBadgeOnVoiceTile___QlFoOU",
};

module.exports = exports;
